'use strict';

var $ = require('jquery');
var Marionette = require('backbone.marionette');

var Search = require('./search').default;
var Picker = require('./picker').default;

export default Marionette.View.extend({

  tagName: 'div',
  className: 'timezone-container',
  template: require('./templates/container.hbs'),

  regions: {
    search: {
      el: ".timezone-search",
      replaceElement: true,
    },
    picker: {
      el: ".timezone-picker",
      replaceElement: true,
    },
  },

  ui: {
    search: ".timezone-search",
  },

  onTimezoneSearch: function(searchVal) {
    this.picker.setQuery(searchVal);
  },

  initialize: function () {
    this.picker = new Picker();
    this.search = new Search();
    this.listenTo(this.search, 'searchTimezones', this.onTimezoneSearch);
    this.listenTo(this.picker, 'changeTimezone', this.onChangeTimezone);
  },

  onRender: function () {
    this.showChildView('picker', this.picker);
    this.showChildView('search', this.search);
  },

  onChangeTimezone: function () {
    this.triggerMethod('change');
  },

  focusFirst: function () {
    $('.'+this.ui.search[0].className).focus();
  },

});
